export type AdminUser = {
  id: string;
  email: string | null;
  created_at: string;
  last_sign_in_at: string | null;
  banned_until: string | null;
  is_banned: boolean;
  display_name: string | null;
  workspace_label: string | null;
  account_tier: string | null;
  roles: string[];
};

export const TIER_OPTIONS: Array<{ value: string; label: string }> = [
  { value: "any", label: "Any tier" },
  { value: "starter", label: "Starter" },
  { value: "plus", label: "Plus" },
  { value: "pro", label: "Pro" },
  { value: "elite", label: "Elite" },
  { value: "agency", label: "Agency" },
  { value: "comp", label: "Complimentary" },
  { value: "admin_workspace", label: "Admin" },
  { value: "super_admin", label: "Super Admin" },
];

export const ROLE_OPTIONS: Array<{ value: string; label: string }> = [
  { value: "any", label: "Any role" },
  { value: "admin", label: "Admin" },
  { value: "super_admin", label: "Super admin" },
];

export const labelFor = (u: AdminUser) =>
  u.workspace_label || u.display_name || u.email || "Unknown user";
